import * as model from "@/model/master/teamShift/TeamShift";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.TeamShift(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d} 00:00:00`;
}

const baseUrl = process.env.VUE_APP_MASTER_API_URL+'master-service/master';

const teamShiftStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentTeamShift: {},
  },
  mutations: {
    setCurrentTeamShift(state, data) {
      state.currentTeamShift = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("teamShift/setCurrentTeamShift", item, {
        root: true
      });
      router.push({
        name: "teamShiftEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/shift/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/shift/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/shift/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/shift/getLength',
      }, { root: true })
    },
    saveCurrentTeamShift(context) {
      return context.dispatch('saveTeamShift', context.state.currentTeamShift);
    },
    saveTeamShift(context, teamShift) {
      let data = new FormData();
      let id = teamShift.id > 0 ? teamShift.id : -1;
      data.append('id', id);
      data.append('name', teamShift.name);
      data.append('teamCount', teamShift.teamCount);
      data.append('cycleCount', teamShift.cycleCount);
      data.append('startDate', date2str(teamShift.startDate));
      data.append('endDate', date2str(teamShift.endDate));
      data.append('firstStartTime', teamShift.firstStartTime);
      return context.dispatch('api/post', {
        url: baseUrl + '/shift/save',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(teamShiftStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)